<template>
    <div class="modal-content">
        <div class="modal-body">
            <loader />
        </div>
    </div>
</template>

<script>
import loader from './loader.vue';

export default {
    // components
    components: {
		loader
	},
    // data
    data: function() {
        return {
        }
    },
}
</script>

<style scoped>
</style>
